import { render, staticRenderFns } from "./SubscriptionPlansPeriod.vue?vue&type=template&id=42567fbc&scoped=true&"
import script from "./SubscriptionPlansPeriod.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPlansPeriod.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionPlansPeriod.vue?vue&type=style&index=0&id=42567fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42567fbc",
  null
  
)

export default component.exports